import React from 'react'
import "./countdownBox.scss"

const CountdownBox = ({count,className}) => {
    return (
        <div className={"countdown-container pt-3 "+className}>
            <h2 className="h1 text-white text-center">{count}</h2>
        </div>
    )
}

export default CountdownBox
